<template>
	<a
		v-if="href"
		class="link-tag link-tag--link"
		:href="href"
		target="_blank"
		rel="noopener"
	>{{ label }}<span class="link-tag__glyph">↗</span></a>
	<a
		v-else-if="click"
		class="link-tag link-tag--link"
		href="#"
		@click.prevent="click"
	>{{ label }}</a>
	<span
		v-else
		class="link-tag link-tag--data"
	>{{ label }}</span>
</template>

<script>
/**
 * Inline emphasis for a named token inside prose. Flows with the surrounding
 * text (inherits font-size, wraps naturally) while marking the token as
 * either a link or a piece of data.
 *
 * Three flavours:
 *   href="..."    — external link, opens in new tab (blue, ↗ glyph)
 *   :click="fn"   — internal action, typically opens a side-window (blue)
 *   (neither)     — data tag (lighter gray), not interactive
 *
 * Used by FraudEvidenceView to weave factual pivots (employees, invoices,
 * orders, e-conomic URLs, dates, leave types, …) into the evidence
 * sentence. Links and data use different colours so a reviewer can tell at
 * a glance what's clickable.
 */
export default {
	props: {
		label: { type: String, required: true },
		href:  { type: String,  default: null },
		click: { type: Function, default: null }
	}
};
</script>

<style lang="scss" scoped>
.link-tag {
	display: inline;
	padding: 1px 6px;
	margin: 0 1px;
	border-radius: 4px;
	font-size: inherit;
	line-height: inherit;
	text-decoration: none;
	white-space: nowrap;

	/* Link — clickable (blue accent) */
	&--link {
		background: rgba(99, 158, 255, 0.14);
		color: #7aadff;
		cursor: pointer;

		&:hover {
			background: rgba(99, 158, 255, 0.28);
			color: #ffffff;
		}
	}

	/* Data — static (neutral light gray) */
	&--data {
		background: rgba(255, 255, 255, 0.06);
		color: #c8c9cc;
	}

	&__glyph {
		font-size: 0.8em;
		opacity: 0.6;
		margin-left: 2px;
	}
}
</style>
